// «Активность пользователей» в админке: порядок серверов, «давно не заходили», подпись последнего захода.
// Даты — ISO-дни (YYYY-MM-DD) по MSK от сервера, today — тоже с сервера: без часовых поясов браузера.
// last_seen — время последнего захода по MSK «YYYY-MM-DDTHH:MM» (у старых заходов нет — только день).

export const STALE_DAYS = 14;

const dayNumber = (iso) => Math.round(Date.parse(`${iso}T00:00:00Z`) / 86400000);

export const daysSince = (lastDay, today) => (lastDay ? dayNumber(today) - dayNumber(lastDay) : null);

// Не заходили ни разу или STALE_DAYS дней и больше
export const isStale = (lastDay, today) => {
  const days = daysSince(lastDay, today);
  return days === null || days >= STALE_DAYS;
};

const serverLastSeen = (server) => (server.members || []).reduce((max, m) => (m.last_seen > max ? m.last_seen : max), '');

// Сверху — где заходили недавно (в один день — по времени), не заходившие — внизу; одинаково — по названию
export const sortServers = (servers, today) =>
  [...servers].sort((a, b) => {
    const da = daysSince(a.last_day, today) ?? Infinity;
    const db = daysSince(b.last_day, today) ?? Infinity;
    return da - db || serverLastSeen(b).localeCompare(serverLastSeen(a)) || a.name.localeCompare(b.name, 'ru');
  });

// Сразу видны серверы, где заходили меньше STALE_DAYS дней назад, остальные — под «Показать все»
export const splitServers = (servers, today) => {
  const sorted = sortServers(servers, today);
  return {
    recent: sorted.filter((s) => !isStale(s.last_day, today)),
    rest: sorted.filter((s) => isStale(s.last_day, today)),
  };
};

// Пользователи сервера: недавние сверху (в один день — по времени), не заходившие — внизу
export const sortMembers = (members, today) =>
  [...members].sort((a, b) => {
    const da = daysSince(a.last_day, today) ?? Infinity;
    const db = daysSince(b.last_day, today) ?? Infinity;
    return da - db || (b.last_seen || '').localeCompare(a.last_seen || '') || a.name.localeCompare(b.name, 'ru');
  });

// Сразу видны заходившие меньше STALE_DAYS дней назад, остальные — под «Показать всех»
export const splitMembers = (members, today) => {
  const sorted = sortMembers(members, today);
  return {
    recent: sorted.filter((m) => !isStale(m.last_day, today)),
    rest: sorted.filter((m) => isStale(m.last_day, today)),
  };
};

// Карточки итогов над списком (summary с сервера, без админов)
export const summaryCards = (summary) => {
  const percent = summary.users ? Math.round((summary.active_30 / summary.users) * 100) : 0;
  return [
    { key: 'users', label: 'Пользователей', value: String(summary.users), hint: `с сервером: ${summary.users_with_server}` },
    { key: 'servers', label: 'Серверов', value: String(summary.servers), hint: 'добавлено пользователями' },
    { key: 'active', label: 'Активных за 30 дней', value: String(summary.active_30), hint: `${percent}% от всех` },
    {
      key: 'daily',
      label: 'Заходов в день',
      value: summary.avg_daily.toLocaleString('ru-RU', { maximumFractionDigits: 1 }),
      hint: summary.avg_days ? `разных пользователей, в среднем за ${summary.avg_days} дн.` : 'заходов ещё не было',
    },
  ];
};

// «2026-10-13» → «13.10.2026»
export const formatDay = (iso) => (iso ? iso.split('-').reverse().join('.') : '');

// Последний заход пользователя: «сегодня в 14:25», «вчера в 09:10», «24.10.2026 в 14:25»; без времени — день
export const lastSeenText = (member, today) => {
  if (!member.last_day) return 'не заходили';
  const days = daysSince(member.last_day, today);
  const day = days <= 0 ? 'сегодня' : days === 1 ? 'вчера' : formatDay(member.last_day);
  const time = member.last_seen ? member.last_seen.slice(11, 16) : '';
  return time ? `${day} в ${time}` : day;
};

export const lastVisitText = (lastDay, today) => {
  const days = daysSince(lastDay, today);
  if (days === null) return 'не заходили';
  if (days <= 0) return 'сегодня';
  if (days === 1) return 'вчера';
  return `${days} дн. назад`;
};
